import Vue from "vue";
import axios from "axios";

const actions = {
  async savePharmacist({ commit, dispatch, getters, rootState }, pharmacist) {
    console.debug(pharmacist.id);
    if (!pharmacist.id) return false;

    var result1 = await Vue.axios.patch(
      "/practitioners/" + pharmacist.id,
      pharmacist
    );
    var result2 = await Vue.axios.patch("/people/" + pharmacist.id, pharmacist);
    if (result1 && result2) {
      return true;
    }
    await dispatch("load", pharmacist.id);
    return [result1, result2];
  },
  async createPharmacist({ commit, dispatch, getters, rootState }, pharmacist) {
    console.debug("createPharmacist:", pharmacist);
    if (!pharmacist) return false;

    var result1 = await Vue.axios.post("/people/", pharmacist);
    console.debug("createPharmacist: result1: ", result1);
    if (result1 && result1.data) {
      pharmacist.id = result1.data.id;
      var result2 = await Vue.axios.patch("/practitioners/", pharmacist);
      console.debug("createPharmacist: result2: ", result2);
    }
    return { person: result1.data, practitioner: result2.data };
    // if (result1 && result2) {
    //   return true;
    // }
  },

  async search({ state, commit, getters }, params) {
    try {
      commit("clear");
      const results = await axios("/people", { params });
      console.debug("getting from search", results);

      let returnArray = [];
      if (results && results.data) {
        for (let person of results.data) {
          await new Promise(res => {
            setTimeout(() => {
              let personId = person.id;
              commit("store", person);
              returnArray.push(state.cache[personId]);
              // commit("saveSearchResults", returnArray);
              res();
            }, 0);
          });
        }
      }
      commit("saveSearchResults", returnArray);
      return returnArray;
    } catch (e) {
      console.error("error getting from search", e);
    }
  },
  async getById({ state, dispatch }, id) {
    if (!id) {
      return {};
    }
    if (state.cache[id]) {
      return state.cache[id];
    } else {
      return await dispatch("load", id);
    }
  },
  async load({ state, commit }, person) {
    let personId;

    if (typeof person === "object" && person.id !== undefined) {
      personId = person.id;
    } else {
      personId = person;
    }
    console.debug("supplied personId: ", personId);

    if (!person && person !== null && state.selectedId) {
      personId = state.selectedId;
    }
    console.debug("personId: ", personId);

    if (!personId) {
      return false;
    }
    if (state.loading && state.cache[personId]) {
      console.debug("Returning person from Cache: ");
      return state.cache[personId];
    }
    try {
      console.debug("loading person: ", personId);
      commit("loading", true);
      const loadedPerson = await axios.get(`/people/${personId}/`, {
        params: {
          filter: {
            include: [
              {
                relation: "comments",
                scope: { order: "createdate DESC" }
              },
              { apc: true },
              { addresses: true },
              { workAddresses: true },
              { postcodeinfo: true },
              { quals: true },
              {
                practitioner: [
                  "conditionsonscopeofpractice",
                  "cases",
                  "payments",
                  "enhance",
                  "scopesonpractice",
                  "certificates",
                  "statuses"
                ]
              }
            ]
          }
        }
      });
      if (loadedPerson.data) {
        commit("store", loadedPerson.data);
        // commit('select', loadedPerson.id)
      } else {
        throw new Error("No Person Found");
      }
    } catch (e) {
      console.error("unable to load: ", e);
    } finally {
      commit("loading", false);
    }
    commit("loading", false);
    console.debug("finished loading: ", state);
    return state.cache[personId];
  },
  async update({ state, commit, getters, dispatch }, newPerson) {
    console.debug("updating person prop: ", newPerson);
    try {
      commit("loading", true);
      let person = newPerson;
      if (!newPerson.id) {
        person = getters.current;
        newPerson.id = person.id;
      } else {
        person = state.cache[newPerson.id];
      }
      let propsChanged = false;
      for (const prop in newPerson) {
        if (person[prop] !== newPerson[prop]) {
          propsChanged = true;
        }
      }

      if (!propsChanged) {
        console.debug("no props changed:", newPerson, person);
        // eslint-disable-next-line
        return
      }

      // add for optimistic UI
      commit("updateProps", newPerson);

      console.debug("updating person: ", person, newPerson);
      let updatedPerson = await axios.patch(`people/${person.id}`, newPerson);
      if (updatedPerson.data) {
        updatedPerson = updatedPerson.data;
      }
      console.debug("updatedperson", updatedPerson);
      newPerson.id = updatedPerson.id;

      // if different, and most recent change, then update, otherwise skip
      commit("updateProps", updatedPerson);
      // await dispatch('load', updatedPerson)
    } catch (e) {
      console.error("error updating prop on person: ", e);
    } finally {
      commit("loading", false);
    }
  },
  async addRel({ dispatch, getters }, { type, relation, relPath = true }) {
    const person = getters.current;
    console.debug("person: ", person);
    let rel;
    try {
      rel = await axios.head(`people/${person.id}/${type}/rel/${relation.id}`);
    } catch (e) {
      if (!rel) {
        rel = await axios.put(`people/${person.id}/${type}/rel/${relation.id}`);
      }
    }
    console.debug(rel);
    dispatch("load");
  },
  async removeRel({ dispatch, getters }, { type, relation, relPath = true }) {
    const person = getters.current;
    console.debug("person: ", person, type, relation);
    await axios.delete(`people/${person.id}/${type}/rel/${relation.id}`);
    dispatch("load");
  },
  async select({ dispatch, commit, state }, id) {
    commit("select", id);
    return await dispatch("load", id);
  }
};

const state = {
  pharmacists: [],
  pharmacist: {},
  cache: {},
  selectedId: null,
  loading: false,
  search: {
    string: "",
    filters: {
      practicingStatusId: []
    },
    options: { rowsPerPage: 10 },
    expanded: []
  },
  recentSearchResults: []
};

const mutations = {
  clear(state) {
    console.debug("clearing people cache and recent search results");
    let selectedPerson = state.cache[state.selectedId];
    state.cache = { [state.selectedId]: selectedPerson };
    state.recentSearchResults = [];
  },
  store(state, person) {
    // person should be actual person object
    if (!person.id) {
      return;
    }
    // console.debug("storing: ", person);
    Vue.set(state.cache, person.id, person);
    // state.cache = { ...state.cache, [person.id]: { ...person } };
    return state.cache[person.id];
  },
  select(state, personId) {
    state.selectedId = personId;
    // console.debug("selected personId: ", personId);
  },
  loading(state, isLoading) {
    console.debug("setting person loading state to :", isLoading);
    Vue.set(state, "loading", !!isLoading);
    // return state;
  },
  updateProps(state, newPerson) {
    console.debug("update props: ", newPerson);
    for (const prop in newPerson) {
      if (prop === "id") {
        continue;
      }
      console.debug("updating prop: ", prop);
      Vue.set(state.cache[newPerson.id], prop, newPerson[prop]);
    }
  },
  setSearchString(state, string) {
    state.search.string = string;
    return state;
  },
  saveSearchResults(state, results) {
    state.recentSearchResults = results;
    console.debug("vuex: mutating recentSearchResults: ", results);
  },
  setSearchOptions(state, options) {
    state.search.options = { ...options };
  },
  setSearchFilters(state, filters) {
    state.search.filters = { ...filters };
  },
  setSearchExpanded(state, expanded) {
    state.search.expanded = [...expanded];
  }
};

const getters = {
  current(state) {
    console.debug(
      "getter returning the person: ",
      state,
      state.cache[state.selectedId]
    );
    return state.cache[state.selectedId] || {};
  },
  getById: state => id => {
    return state.cache[id];
  },
  isLoading: state => {
    if (state.loading == true) {
      return true;
    } else {
      return false;
    }
  },
  searchResults: state => {
    return state.recentSearchResults;
  },
  getSearchString: state => {
    return state.search.string;
  },

  getSearchOptions: state => {
    return state.search.options;
  },

  getSearchFilters: state => {
    return state.search.filters;
  },
  getSearchExpanded: state => {
    return state.search.expanded;
  }
};

export default { actions, state, getters, mutations };
